import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  FileInput,
  Grid,
  LoadingOverlay,
  PasswordInput,
  ScrollArea,
  Select,
  SimpleGrid,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { UPDATE_DRIVER, UPDATE_SALES } from "apollo/mutuations";
import { GET_REGIONS } from "apollo/queries";
import axios from "axios";
import ImageUploader from "components/controls/ImageUpload";
import { customLoader } from "components/utilities/loader";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { API } from "utiles/url";

export const SalesEditModal = ({
  activePage,
  fetchData,
  editRow,
  setOpenedEdit,
}) => {
  const [regionDropDownData, setRegionDropDownData] = useState([]);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [initialProfileImage, setInitialProfileImage] = useState(null);

  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      city: "",
      subcity: "",
      address: "",
      house_number: "",
      woreda: "",
      region: "1",
      password: "",
    },
  });
  const previews = files.map((file, index) => {
    const imageUrl = URL.createObjectURL(file);
    return (
      <img
        key={index}
        src={imageUrl}
        alt=""
        width="130"
        onLoad={() => URL.revokeObjectURL(imageUrl)}
      />
    );
  });
  const [updateSales, { loading: salesLoading }] = useMutation(UPDATE_SALES);
  const { height } = useViewportSize();
  if (initialProfileImage && files.length === 0) {
    previews.unshift(
      <img key="initial" src={initialProfileImage} alt="Profile" width="130" />
    );
  }
  const { loading: region_loading } = useQuery(GET_REGIONS, {
    variables: { first: 100, page: 1 },
    onCompleted(data) {
      const newArr = data.regions.data.map((element) => ({
        label: element.name,
        value: element.id,
      }));
      setRegionDropDownData(newArr);
    },
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message: error?.graphQLErrors?.[0]?.message || "Failed to get region",
      });
    },
  });
  useEffect(() => {
    if (editRow) {
      console.log(editRow);
      form.setValues({
        name: editRow.user.name || "",
        phone: editRow.user.phone || "",
        email: editRow.user.email || "",
        city: editRow.city || "",
        subcity: editRow.subcity || "",
        address: editRow.address || "",
        region: editRow.region.id || "",
        woreda: editRow.woreda || "",
        region: editRow.region.id || "",
      });
      if (editRow.user.profile_image) {
        setInitialProfileImage(editRow.user.profile_image);
      }
    }
  }, [editRow]);
  const submit = () => {
    let variables = {
      id: editRow.id,
      name: form.getInputProps("name").value,
      email: form.getInputProps("email").value,
      password: form.getInputProps("password").value,
      phone: form.getInputProps("phone").value,
      city: form.getInputProps("city").value,
      woreda: form.getInputProps("woreda").value,
      subcity: form.getInputProps("subcity").value,
      gender: form.getInputProps("gender").value,
      region_id: form.getInputProps("region").value,
      address: form.getInputProps("address").value,
      profile_image: files[files.length - 1],
    };
    if (files.length > 0) {
      variables.profile_image = files[files.length - 1];
    }
    updateSales({
      variables,
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Sales Updated Successfully",
        });

        setOpenedEdit(false);
      },
      onError(error) {
        setOpenedEdit(true);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Update Sales",
        });
      },
    });
  };

  const handleFileChange = (event) => {
    setFiles(Array.from(event.target.files));
  };
  const setRegionDropDownValue = (val) => {
    form.setFieldValue("region", val);
  };

  return (
    <>
      <LoadingOverlay
        visible={editRow == null || salesLoading || region_loading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Name"
                  placeholder="Name"
                  {...form.getInputProps("name")}
                />
                <TextInput
                  required
                  label="Email"
                  placeholder="Email"
                  {...form.getInputProps("email")}
                />
                <TextInput
                  required
                  label="Phone"
                  placeholder="Phone"
                  maxLength={13}
                  {...form.getInputProps("phone")}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9+]/g, "");
                  }}
                />
                <TextInput
                  required
                  label="Woreda"
                  placeholder="Woreda"
                  {...form.getInputProps("woreda")}
                />
                <ImageUploader
                  defaultImage={initialProfileImage}
                  multiple={false}
                  onChange={(selectedFiles) => {
                    setFiles(selectedFiles);
                  }}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Address"
                  placeholder="Address"
                  {...form.getInputProps("address")}
                />
                <Select
                  label="Select Region"
                  searchable
                  data={regionDropDownData}
                  value={form.getInputProps("region").value.toString()}
                  onChange={setRegionDropDownValue}
                />
                <TextInput
                  required
                  label="City"
                  placeholder="City"
                  {...form.getInputProps("city")}
                />
                <TextInput
                  placeholder="SubCity"
                  label="Sub City"
                  {...form.getInputProps("subcity")}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={4}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "10px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};
